export default __webpack_public_path__ + "static/Rain and Sunshine cmprsd-503322e8ff553feb983c4525ca34e5f6.mp3";